import React from "react";
import { 
  MdPayments, 
  MdTrendingUp, 
  MdSecurity, 
  MdGroups 
} from "react-icons/md"; // or react-icons/md based on your setup
import { MdTerminal } from "react-icons/md";

export default function WhyChooseUs() {
  const highlights = [
    {
      icon: <MdPayments />,
      title: "Fixed-Fee Transparency",
      desc: "Absolute pricing predictability with clear fixed fees. No hidden hourly surprises, allowing clean corporate budgeting."
    },
    {
      icon: <MdTrendingUp />,
      title: "Proven Scale Advisory",
      desc: "Trusted by pre-revenue development startups up to large-scale enterprise operations managing $200M in annual turnovers."
    },
    {
      icon: <MdSecurity />,
      title: "NBAA Registered Practice",
      desc: "Fully compliant public practitioners bound by rigorous international regulatory criteria and weekly technical training loops."
    },
    {
      icon: <MdGroups />,
      title: "National Coverage Ecosystem",
      desc: "Strategic administrative offices positioned in Dar es Salaam and Dodoma, built to support businesses anywhere in Tanzania."
    }
  ];

  return (
    <section className="why-choose-us-section py-5 bg-white border-top">
      <div className="container py-2">
        <div className="row g-5 align-items-center">
          
          {/* LEFT COLUMN: CRISP VALUE PROPOSITION AREA */}
          <div className="col-lg-5" data-aos="fade-right">
            <span className="overview-kicker text-secondary text-uppercase font-weight-bold tracking-wider">
              The Blessing Advantage
            </span>
            <h2 className="overview-title text-primary font-weight-bold mt-2 mb-3">
              Why Forward-Thinking Enterprises Partner With Us
            </h2>
            <p className="overview-paragraph text-muted-narrative mb-4 font-15">
              We break down institutional financial complexities into highly executionable strategic frameworks. Our multi-disciplinary team brings localized tax intelligence and cross-border standards to your boardroom table.
            </p>
            
            {/* COMPACT STICKY STATS MATRIX CARD */}
            <div className="overview-sidebar-card border p-3 rounded bg-light-surface-tint shadow-sm">
              <ul className="sidebar-bullet-list list-unstyled d-flex flex-column gap-2 mb-0 font-14">
                <li className="d-flex align-items-center gap-2">
                  <MdTerminal className="text-secondary" /> 
                  <span className="text-primary font-weight-bold">Timely Professional Execution Metrics</span>
                </li>
                <li className="d-flex align-items-center gap-2">
                  <MdTerminal className="text-secondary" /> 
                  <span className="text-primary font-weight-bold">Client-First Referral Success Rate</span>
                </li>
              </ul>
            </div>
          </div>

          {/* RIGHT COLUMN: HIGH-DENSITY 4-GRID HIGHLIGHT MATRIX */}
          <div className="col-lg-7" data-aos="fade-left">
            <div className="row g-3">
              {highlights.map((item, index) => (
                <div className="col-sm-6" key={index}>
                  <div className="premium-capability-card h-100 bg-white p-3 border rounded shadow-sm d-flex flex-column transition-base">
                    {/* ICON CONTEXT BOX */}
                    <div className="capability-icon-box text-secondary mb-2 fs-3">
                      {item.icon}
                    </div>
                    {/* HIGHLIGHT TITLE */}
                    <h3 className="capability-title text-primary font-16 font-weight-bold mb-2">
                      {item.title}
                    </h3>
                    {/* COMPACT NARRATIVE TEXT */}
                    <p className="capability-desc text-muted mb-0 font-13 flex-grow-1 line-height-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}